<div class="row m-0" style="overflow: hidden;">
    <div class="col-6">
        <div class="row mt-5">
            <div class="col-2"></div>
            <div class="col">
                <img src="../../assets/img/outlive-chat.svg" width="150">
                <div style="margin-top: 8rem;">
                    <div class="header-content">
                        Welcome
                    </div>
                    <div class="mt-4 card border-0" id="userform">
                        <mat-form-field appearance="outline" class="w-100 top-left-border top-right-border">
                            <mat-label>Email</mat-label>
                            <input matInput [(ngModel)]="email">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100 bottom-left-border bottom-right-border">
                            <mat-label>Password</mat-label>
                            <input matInput [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password" (keydown.enter)="loginUser()">
                            <mat-icon matSuffix class="primary-eye" (click)="showPassword = !showPassword">{{showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                        </mat-form-field>
                    </div>
                    <div class="mt-3 cursor text-right font-13 mr-2" style="color: #3F3C3C;" (click)="navToForgotPassword()">Forgot Password?</div>
                    <button class="btn w-100 mt-5 primary-bg text-white" style="height: 55px;" [disabled]="!email.trim() || !password.trim()" (click)="loginUser()"><span>Login</span></button>
                </div>
            </div>
            <div class="col-2"></div>
        </div>
    </div>
    <div class="col-6 p-0">
        <img class="halfweb-image" src="../../assets/img/signup_bg2.jpg">
    </div>
</div>